import { Component, inject, OnInit } from '@angular/core';
import { TherapistService } from '../../../services/api/TherapistService';
import { Grid_BookingModel } from '../../../models/api/Grid_BookingModel';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TherapistDashboardComponent } from '../../dashboard/dashboard.component';
import { TherapistDashboardService } from '../../../services/api/TherapistDashboardService';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { BookingService } from '../../../services/api/BookingService';
import { BookingModelExtra } from '../../../models/api/BookingModelExtra';
import { UtcToLocalPipe } from '../../../pipes/utc-to-local.pipe';
import { AuthService } from '../../../services/auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-queue-mine',
  standalone: true,
  imports: [DatePipe, MatButtonModule, MatIconModule, UtcToLocalPipe],
  templateUrl: './queue-mine.component.html',
  styleUrl: './queue-mine.component.scss'
})

export class QueueMineComponent implements OnInit {

  queue: Grid_BookingModel[] = [];

  acceptMassageClicked: boolean = false;


  readonly dialog = inject(MatDialog);

  private acceptBookingDialogRef: MatDialogRef<AcceptAnyBookingDialog> | null = null;
  currentBooking: BookingModelExtra = new BookingModelExtra;


  constructor(
    private therapistService: TherapistService,
    private router: Router,
    private bookingService: BookingService,
    private therapistDashboardService: TherapistDashboardService,
    private authService: AuthService,
    private snackbar: MatSnackBar,
  ) {

  }

  ngOnInit(): void {
    this.getBookings();

  }

  getBookings() {

    this.bookingService.getCurrentBooking().subscribe({
      next: (data) => {
        if (data.bookingID > 0) {
          this.currentBooking = data;
        }
      },
      error: (err) => {

        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your sesison has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authosied to get your current booking', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Current Booking not found, please try again', 'dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please check the booking and try again', 'dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode >= 500) {
          this.snackbar.open('Server error, please try again later', 'dismiss');
        }



      }
    })

    this.therapistService.getBookingsWaitingForMe().subscribe({
      next: (data) => {
        this.queue = data;

      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your sesison has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authosied to get bookings waiting for you', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Bookings not found, please try again', 'dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please check the booking and try again', 'dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode >= 500) {
          this.snackbar.open('Server error, please try again later', 'dismiss');
        }
      }
    })
  }

  backToDashboard() {
    this.router.navigate(['therapist-portal', 'dashboard']);
  }

  acceptMassage(bookingID: number) {
    this.acceptMassageClicked = true;
    this.acceptBookingDialogRef = this.dialog.open(AcceptAnyBookingDialog, {
      panelClass: 'therapist-portal-dialog',
      disableClose: true,
      backdropClass: 'dialog-blur',
    })


    this.acceptBookingDialogRef.afterClosed().subscribe({
      next: (result) => {
        this.therapistDashboardService.forceStartBooking(bookingID).subscribe({
          next: (data) => {
            this.router.navigate(['therapist-portal', 'dashboard']);
          },
          error: (err) => {
            if (err.errorCode === 0) {
              this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
            }
            else if (err.errorCode === 401) {
              this.snackbar.open('Your sesison has expired. Please log in and try again', 'Dismiss');
              this.logOutUser();
            }
            else if (err.errorCode === 403) {
              this.snackbar.open('You are not authosied to accept this massage', 'Dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
            else if (err.errorCode === 404) {
              this.snackbar.open('Massage details not found, please try again', 'dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
            else if (err.errorCode === 400) {
              this.snackbar.open('Invalid request, please check the massage and try again', 'dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
            else if (err.errorCode >= 500) {
              this.snackbar.open('Server error, please try again later', 'dismiss');
            }
          }
        })
      },
      error: (err) => {

        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your sesison has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authosied to accept this massage', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Massage details not found, please try again', 'dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please check the massage and try again', 'dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode >= 500) {
          this.snackbar.open('Server error, please try again later', 'dismiss');
        }


        this.acceptMassageClicked = false;
      }
    })
  }

  logOutUser() {
    this.authService.logout().subscribe({});
    this.router.navigate(['login']);
  }
}



@Component({
  selector: 'accept-any-booking-dialog',
  templateUrl: '../../dashboard/booking-accept-dialog.html',
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
})

export class AcceptAnyBookingDialog {
  constructor(private dialogRef: MatDialogRef<AcceptAnyBookingDialog>) {
  }
}